






































import { defineComponent, computed } from '@vue/composition-api';
import { OnClickOutside } from '@/app/components';

export default defineComponent({
    name: 'CardLayoutCard',
    components: { OnClickOutside },
    props: { withTags: { type: Boolean, default: false }, withFooter: { type: Boolean, default: false } },
    setup(props) {
        const tags = computed(() => {
            if (!props.withTags) return [];

            const calculatedTags = [];
            const availableTags = ['abc', 'deeeeff', 'fooobar', 'defg'];
            const numberOfTags = Math.floor(Math.random() * 4);
            for (let t = 0; t < numberOfTags; t++) {
                calculatedTags.push(availableTags[t]);
            }
            return calculatedTags;
        });

        return { tags };
    },
});
